import { render, staticRenderFns } from "./material-item-in-list.vue?vue&type=template&id=670e21ce&scoped=true&"
import script from "./material-item-in-list.vue?vue&type=script&lang=js&"
export * from "./material-item-in-list.vue?vue&type=script&lang=js&"
import style0 from "./material-item-in-list.vue?vue&type=style&index=0&id=670e21ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e21ce",
  null
  
)

export default component.exports